<template>
	<div class="mds-month-render" :class="componentClasses" v-on="$attrs">
		<div class="mds-month-render__header">
			<button
				v-if="isFirst"
				class="change-month previous"
				@click="changeMonth('previous')"
			/>

			<button
				v-if="isLast"
				class="change-month next"
				@click="changeMonth('next')"
			/>

			{{ monthName }} {{ year }}
		</div>

		<div class="mds-month-render__content">
			<div class="weekdays">
				<div v-for="weekday of weekdays" :key="weekday">{{ weekday }}</div>
			</div>
			<div class="days">
				<div
					v-for="(day, index) of days"
					class="day"
					:class="getDayClasses(day)"
					:key="uid + '_day_' + index"
					@click="selectDay(day)"
					@mouseenter="onMouseEnterDate(day)"
					@mouseleave="onMouseLeaveDate(day)"
				>
					{{ day }}
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" src="./VMonthRenderer.scss"/>

<script>
import Utils     from '@/core/utils/Utils';
import DateSimple from '@/core/types/DateSimple';
import UniqueIdMixin from "@/lib/mixins/component-unique-id";

export default {
	name: "VMonthRenderer",

	mixins: [UniqueIdMixin],

	props: {
		/**
		 * Месяц является первым при рендере
		 */
		isFirst: {
			type: Boolean,
			default: true,
		},
		/**
		 * Месяц является полседним при рендере
		 */
		isLast: {
			type: Boolean,
			default: true,
		},
		/**
		 * Номер месяца для рендера
		 */
		month: {
			type: Number,
			default: 0,
		},
		/**
		 * Год для рендера
		 */
		year: {
			type: Number,
			default: 2019,
		},
		/**
		 * Номер дня недели, который принят первым днем. 0 - воскресенье, 1 - понедельник и т.д.
		 */
		firstDayOfWeek: {
			type: Number,
			default: 1,
		},
		/**
		 * Функция, определяющая является ли дата выбранной в родительском компоненте
		 * @param {Date} data
		 * @return boolean
		 */
		isSelected: Function,
		/**
		 * Функция, определяющая входит ли дата в выбранный период в родительском компоненте
		 * @param {Date} data
		 * @return boolean
		 */
		isInRange: Function,

		/** Функция, определяющая доступна ли дата  */
		isDisabled: Function,
	},
	computed: {
		componentClasses() {
			return { first: this.isFirst, last: this.isLast };
		},
		monthName() {
			return Utils.date.getMonthName(this.month);
		},
		days() {
			return Utils.date.getMonthDays(this.month, this.year);
		},
		weekdays() {
			return Utils.date.getWeekDays(1);
		},
		hasHelperTextSlot() {
			return this.$slots["helper-text"];
		},
	},
	data() {
		return {
			currentDate: null,
		};
	},
	methods: {
		getDate(day) {
			return new DateSimple(new Date(this.year, this.month, day));
		},
		changeMonth(direction) {
			this.$emit("change-month", { direction });
		},
		selectDay(day) {
			/** если дата disabled, то её нельзя выбрать */
			const date = this.getDate(day);
			if (this.isDisabled && this.isDisabled(date)) return;

			if (day) {
				this.$emit("select-day", this.getDate(day));
			}
		},
		getDayClasses(day) {
			const classes = {};

			if (!day) {
				classes["empty"] = true;
				return classes;
			}

			const date = this.getDate(day);

			classes["today"] = date.isToday();

			if (this.isDisabled && this.isDisabled(date)) {
				classes["disabled"] = true;
			}

			if (this.isSelected && this.isSelected(date)) {
				classes["selected"] = true;
			}

			if (this.isInRange && this.isInRange(date)) {
				classes["pre-selected"] = true;
			}
			return classes;
		},
		onMouseEnterDate(day) {
			if (!day) return;

			const date = this.getDate(day);
			this.$emit("mouse-enter-date", date);
		},
		onMouseLeaveDate(day) {
			if (!day) return;

			const date = this.getDate(day);
			this.$emit("mouse-leave-date", date);
		},
	},
};
</script>
